var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 22.75H34.375V19H0.625V22.75ZM0.625 13.375H34.375V9.625H0.625V13.375ZM0.625 0.25V4H34.375V0.25H0.625Z",
    fill: "#6B2C90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamBurgerMenu);
export default __webpack_public_path__ + "static/media/HamBurgerMenu.02bb2d78b2ddbdc13e176c6e2ae7d925.svg";
export { ForwardRef as ReactComponent };